angular.module('natgeo').factory('ColorizeFactory', ['container', 
function ColorizeFactory(container) 
{
	var createFilter = function(base, target) {
		return new createjs.ColorFilter( target.r / base.r, target.g / base.g, target.b / base.b, 1, 0, 0, 0, 0);
	};
	
	return function( img ) 
	{
		// Call scale to ensure data-rect has been removed
		img.scale( container.getScale() );

		var actualImage = img[0];
		var canvas = $('<canvas>');
		var actualCanvas = canvas[0];
		var stage = new createjs.Stage( actualCanvas );
		var bitmap = new createjs.Bitmap( actualImage );
		var scale = parseFloat( img.data( 'scale' ) ) || 1.0;
		var width, height, imageData;

		var recalculate = function()
		{
			width = parseInt( img.data('width') ) || actualImage.width;
			height = parseInt( img.data('height') ) || actualImage.height;
			imageData = $.extend( {}, img.data() );
		};

		var loaded = isImageLoaded( actualImage );
		var replaced = false;

		if ( loaded )
		{
			recalculate();
		}
		else
		{
			actualImage.onload = function()
			{
				loaded = true;

				recalculate();

				result.redraw();
			};
		}
		
		var result = 
		{
			setColor: function(base, target) 
			{
				bitmap.filters = [ createFilter( base, target ) ];

				return result.redraw();
			},
			redraw: function() 
			{
				var containerScale = container.getScale();

				canvas.data( imageData );
				canvas.scale( containerScale );

				bitmap.scaleX = scale * containerScale;
				bitmap.scaleY = scale * containerScale;

				if (!loaded)
				{
					return;
				}

				bitmap.cache( 0, 0, width, height );
				stage.addChild( bitmap );

				result.update();

				return result;
			},
			update: function()
			{
				try
				{
					stage.update();

					if ( !replaced )
					{
						img.replaceWith( canvas );
						replaced = true;
					}
				}
				catch (e)
				{
					if ( console )
					{
						console.log( e );
					}
				}

				return result;
			},
			stage: stage,
			bitmap: bitmap,
			canvas: canvas,
			width: width, 
			height: height,
			scale: scale,
			imageData: imageData
		};
		
		container.$screen.on( 'landscape', result.redraw );
		
		result.redraw();

		return result;
	};
}]);